import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import PlayerNav from './PlayerNav';
import type { PlayerNavProps, PlayerNavAPI, PlayerNavHandle } from './types';

declare global {
  interface Window {
    mountPlayerNav: (containerId: string, props: PlayerNavProps) => PlayerNavHandle;
  }
}

window.mountPlayerNav = function mountPlayerNav(
  containerId: string,
  props: PlayerNavProps,
): PlayerNavHandle {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error('PlayerNav: container not found:', containerId);
    return { unmount: () => {}, get api() { return null; } };
  }

  const apiRef = createRef<PlayerNavAPI>();
  const root = createRoot(container);
  root.render(React.createElement(PlayerNav, { ...props, ref: apiRef }));

  return {
    unmount: () => root.unmount(),
    get api() { return apiRef.current; },
  };
};
